import React, { useState } from "react";
import { Link } from "react-router-dom";
import CarRentalModal from "../Pages/CarRentalModal";

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const slides = [
    {
      imgSrc: "./assets/images/car-3.png",
      altText: "rent car",
    },
    {
      imgSrc: "./assets/images/car-1.png",
      altText: "rent car",
    },
    {
      imgSrc: "./assets/images/car-4.png",
      altText: "rent car",
    },
  ];

  const goToNextSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
  };

  const goToPreviousSlide = () => {
    setCurrentSlide((prevSlide) =>
      prevSlide === 0 ? slides.length - 1 : prevSlide - 1
    );
  };

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <section
      className="section hero has-bg-image"
      aria-label="home"
      style={{ backgroundImage: "url('./assets/images/blue.png')" }}
    >
      <div className="container">
        <div className="hero-content">
          <h1 className="h1 hero-title" style={{ fontSize: "25px" }}>
            Reliable Car Services for Your Comfort and Convenience
          </h1>

          <p className="hero-text" style={{ fontSize: "15px" }}>
            We offer prompt, professional, and safe taxi rides for all your
            travel needs. Whether you're going to the airport or around town,
            we've got you covered.
          </p>

          <div className="btn-wrapper">
            <Link to="rentals" className="btn btn-primary">
              Rentals
            </Link>

            <Link to="taxi" className="btn btn-outline">
              Taxis
            </Link>

            <button className="btn btn-outline" onClick={openModal}>
              Book a Car
            </button>
          </div>
        </div>

        <div className="hero-slider" data-slider>
          <div className="slider-inner">
            <ul
              className="slider-container"
              data-slider-container
              style={{
                transform: `translateX(-${currentSlide * 575}px)`,
                transition: "transform 0.5s ease-in-out",
              }}
            >
              {slides.map((slide, index) => (
                <li className="slider-item" key={index}>
                  <figure
                    className="img-holder"
                    style={{ "--width": 575, "--height": 550 }}
                  >
                    <img
                      src={slide.imgSrc}
                      width="575"
                      height="550"
                      alt={slide.altText}
                      className="img-cover"
                    />
                  </figure>
                </li>
              ))}
            </ul>
          </div>

          <button
            className="slider-btn prev"
            aria-label="slide to previous"
            onClick={goToPreviousSlide}
          >
            <ion-icon name="arrow-back"></ion-icon>
          </button>

          <button
            className="slider-btn next"
            aria-label="slide to next"
            onClick={goToNextSlide}
          >
            <ion-icon name="arrow-forward"></ion-icon>
          </button>
        </div>
      </div>
      <CarRentalModal isOpen={isModalOpen} closeModal={closeModal} />
    </section>
  );
};

export default Hero;
